import memoize from "memoize-one";
import deepEqual from "lodash/isEqual";
import uniq from "lodash/uniq";

export default memoize(
  (arr, prop) => uniq(arr.map(item => item[prop])),
  deepEqual
);
